import { Text } from '@factorialco/deprecated-design-system'
import {
  ProjectionKind,
  useLedgerAccountDetailDataTable,
} from 'generated/resources/datatable.graphql'
import { LedgerAccountDetailFragment } from 'generated/resources/graphql'

import DataTable from 'modules/core/components/DataTable'
import PopoverMenu from 'modules/core/components/PopoverMenu'
import { dateBackendDateTimeToUI } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import { Amount } from '../../JournalsEntry/Datatable/_Amount'

interface Props {
  ledgerAccount: LedgerAccountDetailFragment
  onExportClick: () => void
}

export const LedgerAccountDetailDataTable = ({ ledgerAccount, onExportClick }: Props) => {
  const source = useLedgerAccountDetailDataTable(
    [
      {
        identifier: 'publishedAt',
        title: i18n.t('finance.ledger_account_detail.datatable.fields.recorded_at'),
        kind: ProjectionKind.Custom,
        render: ({ journalEntry_publishedAt }) => (
          <Text.Normal size="200">
            {dateBackendDateTimeToUI(String(journalEntry_publishedAt))}
          </Text.Normal>
        ),
        template: '{{ publishedAt }}',
      },
      {
        identifier: 'journalEntry_description',
        title: i18n.t(
          'finance.ledger_account_detail.datatable.fields.journal_entry_description_v2'
        ),
        kind: ProjectionKind.Custom,
        render: ({ journalEntry_description }) => (
          <Text.Normal size="200">{journalEntry_description}</Text.Normal>
        ),
        template: '{{ journalEntry_description }}',
      },
      {
        identifier: 'journalEntry_number',
        title: i18n.t('finance.ledger_account_detail.datatable.fields.journal_entry_number_v2'),
        kind: ProjectionKind.Custom,
        render: ({ journalEntry_number }) => (
          <Text.Normal size="200">{journalEntry_number}</Text.Normal>
        ),
        template: '{{ journalEntry_number }}',
      },
      {
        identifier: 'debit',
        title: i18n.t('finance.ledger_account_detail.datatable.fields.debit'),
        kind: ProjectionKind.Custom,
        render: ({ debitAmountCents }) => {
          return <Amount amountCents={debitAmountCents} currency={'EUR'} />
        },
        template: '{{ - }}',
      },
      {
        identifier: 'credit',
        title: i18n.t('finance.ledger_account_detail.datatable.fields.credit'),
        kind: ProjectionKind.Custom,
        render: ({ creditAmountCents }) => {
          return <Amount amountCents={creditAmountCents} currency={'EUR'} />
        },
        template: '{{ - }}',
      },
    ],
    {
      variables: {
        ledgerAccountId: ledgerAccount.id,
      },
    }
  )

  return (
    <DataTable
      disableExport
      source={source}
      pagination={{ kind: 'offset', itemsPerPage: 25 }}
      sort={{ path: 'id', direction: 'asc' }}
      customPopoverOptions={
        <PopoverMenu.TouchableOption
          onClick={onExportClick}
          key="finance.chart_of_accounts.export_journal_lines"
          title={i18n.t('common.export')}
        />
      }
    />
  )
}
